import React, { FC } from 'react'
import './item-detail-info.scss'

type Props = {
    title: string
    value?: string | number | boolean
    position?: 'right' | 'left'
    textColor?: string
}

export const ItemDetailInfo: FC<Props> = ({ title, value, position = 'right', textColor = 'default' }) => {

    let valueText: string | null = value?.toString() ?? null
    switch (valueText) {
        case 'true': valueText = 'Yes'; break;
        case 'false': valueText = 'No'; break;
        case null: valueText = 'N/A'; break;
        default: break;
    }

    return (
        <div className={`item-detail-info-row-${textColor}`}>
            <div className={'item-detail-info-title'}>{title}</div>
            <div className={'item-detail-info-colon'}>:</div>
            <div className={`item-detail-info-value-${position}`}>{valueText}</div>
        </div>
    )
}